import React from 'react';

import { Input } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';

import { PartySuggestInput } from './components/PartySuggestInput';
import { INN_MAX_LENGTH } from './constants';
import { IProps } from './interfaces';

export const PartySearch: React.FC<IProps> = (props) => {
  const commonT = useTranslation(NSKeys.common);

  if (!process.env.REACT_APP_DADATA_API_KEY) {
    return (
      <Input
        value={props.value}
        onChange={(event) => props.onChange?.(event.target.value)}
        placeholder={commonT.t('innPlaceholder')}
        disabled={props.disabled}
        maxLength={INN_MAX_LENGTH}
      />
    );
  }

  return <PartySuggestInput {...props} />;
};
